// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3rAbq","title":"FrontImage_title__OWVfO"};